import { bindable, bindingMode } from "aurelia-framework";

/**
 * A simple radio component which cares about setting focus correctly.
 *
 * Usage:
 *
 * <k-radio name="myname" model.bind="mymodel" checked.bind="...">
 *     My Radio Button
 * </k-radio>
 */
export class KRadioCustomElement {
  hasFocus: boolean = false;

  @bindable({ defaultBindingMode: bindingMode.twoWay }) name: string;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) model: any;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) checked: boolean;
}
